// Os tiles do OpenFreeMap trazem o nome em vários idiomas (`name:pt`, `name:es`...), mas o
// estilo Positron só mostra `name_en`. Troca os rótulos de nome para o idioma do app, com
// fallback para o inglês e, por último, para o nome local.
const translateBaseMapLabels = (maplibreMap, language) => {
  const languageCode = language?.split('-')?.[0]
  const labelField = [
    'coalesce',
    ['get', `name:${languageCode}`],
    ['get', 'name_en'],
    ['get', 'name'],
  ]

  maplibreMap
    ?.getStyle()
    ?.layers?.filter((layer) =>
      JSON.stringify(layer?.layout?.['text-field'] ?? '').includes('name'),
    )
    ?.forEach((layer) =>
      maplibreMap.setLayoutProperty(layer.id, 'text-field', labelField),
    )
}

export default translateBaseMapLabels
